import React from 'react';

import { useIntl } from 'react-intl';

import { loginMessages } from 'src/features/auth/utils';
import { GeneralAxiosError } from 'src/registry/types/axios';
import { cn } from 'src/utils/shadcn';

interface LogInFormErrorBlockProps<TData, TError extends GeneralAxiosError<TData>>
    extends React.HTMLAttributes<HTMLParagraphElement> {
    error: TError | null;
}

export default function LogInFormErrorBlock<TData, TError extends GeneralAxiosError<TData> = GeneralAxiosError<TData>>({
    error,
    className,
}: LogInFormErrorBlockProps<TData, TError>) {
    const { formatMessage } = useIntl();

    if (!error) return null;

    if (error?.response?.status === 401) {
        if (error?.response && error.response.data.detail === 'No active account found with the given credentials') {
            return (
                <p className={cn('h-4 text-sm text-red-500', className)}>{formatMessage(loginMessages.loginError)}</p>
            );
        }
    } else return <p className={cn('h-4 text-sm text-red-500', className)}>{error.message}</p>;
}
